import { render } from "./TransparentButton.vue?vue&type=template&id=b4ac3c16"
import script from "./TransparentButton.vue?vue&type=script&lang=js"
export * from "./TransparentButton.vue?vue&type=script&lang=js"

import "./TransparentButton.vue?vue&type=style&index=0&id=b4ac3c16&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__